module.exports = __webpack_public_path__ + "img/heatmap.fef3a648.svg";